// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/engine-starting.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/engine-starting/cold-weather-engine-start.js';
import g1 from '../lessons/aeronautics/engine-starting/engine-starting.js';

mount([g0, g1]);
